"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var context_1 = require("../../../context");
var enums_1 = require("../../../types/enums");
var FormControl_1 = __importDefault(require("../../FormControl"));
var RadioInput_1 = __importDefault(require("../../RadioInput"));
var ConsentToContactInput = function () {
    var trans = context_1.useSemantics().trans;
    var errors = formik_1.useFormikContext().errors;
    return (react_1.default.createElement(FormControl_1.default, { errors: errors.consent, dusk: "consent-field", label: trans('optiiva::labels.consent'), help: trans('project:slhh::labels.householder-consented') },
        react_1.default.createElement(RadioInput_1.default, { dusk: "consent", name: "consent", label: trans('laravel-utils::enum.boolean.yes'), value: enums_1.BooleanOption.YES }),
        react_1.default.createElement(RadioInput_1.default, { dusk: "consent", name: "consent", label: trans('laravel-utils::enum.boolean.no'), value: enums_1.BooleanOption.NO })));
};
exports.default = ConsentToContactInput;
//# sourceMappingURL=ConsentToContactInput.js.map